import { Box, Text, makeUclComponent } from '@rbilabs/universal-components';

import ActionButton from 'components/action-button';
import Picture from 'components/picture';
import BlockRenderer from 'components/sanity-block-renderer';
import { primitive } from 'styles/constants/primitives';

const BACKGROUND_WITH_OPACITY = `${Styles.color.background}AA`;

export const Overlay = Box.withConfig({
  height: 'full',
  width: 'full',
  position: 'absolute',
  backgroundColor: BACKGROUND_WITH_OPACITY,
});

export const CooldownDrawerContainer = Box.withConfig({
  bottom: '0',
  position: 'absolute',
  width: 'full',
  backgroundColor: Styles.color.alert.info.background,
  borderTopRadius: 'md',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '$8',
});

export const Image = Picture.withConfig({
  maxWidth: '100%',
  width: '$48',
});
export const Title = Text.withConfig({
  color: primitive.$white,
  fontFamily: 'heading',
  fontWeight: 'bold',
  fontSize: 'lg',
  lineHeight: 'md',
  marginTop: '$4',
});
export const Description = Text.withConfig({
  color: primitive.$white,
  fontFamily: 'heading',
  fontSize: 'md',
  lineHeight: 'md',
  marginY: '$4',
  textAlign: 'center',
});
export const CTAButton = makeUclComponent(ActionButton).withConfig({
  fontSize: 'md',
  paddingY: '$2',
  paddingX: '$6',
});
export const Terms = BlockRenderer.withConfig({
  textProps: {
    color: primitive.$white,
    fontFamily: 'heading',
    fontSize: 'sm',
    lineHeight: '2xs',
  },
});
